import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UserFuntionService {
    //UserFuntions
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8'
        })
    };
    version = 'v1.0';
    url = environment.apiUrl + this.version + '/UserFuntions';
    constructor(private http: HttpClient) {
    }
    getTreeGroupByUser(): Observable<any>  {
        return this.http.get(this.url + '/GetTreeGroupByUser' , this.httpOptions);
    }
    getPermission(Id:number ,GroupId:number ,IsUser:boolean ): Observable<any>  {
        return this.http.get(this.url + `/GetPermission?Id=${Id}&GroupId=${GroupId}&IsUser=${IsUser}` , this.httpOptions);
    }
    putUserFuntions(node: {Id: number, GroupId: number, IsUser: boolean , InheritanceType: string,AdditionalType : string}, list: any[]){
        let queryString =  Object.keys(node).map(key => key + '=' + node[key]).join('&');
        return this.http.put(this.url + '/Update?' + queryString , list, this.httpOptions);
    }
}
